module.exports = __webpack_public_path__ + "img/motorcycle-orange.0725cf06.svg";